import { useEffect, useState } from "react"

// libraries
import Skeleton from "react-loading-skeleton"
import { Button, Popover, Radio } from "@mui/material"

// providers
import { trans, fromInfo } from "@/_providers/Translation"

// helpers
import Api from "@/_helpers/Api"

// components
import Help from "@/components/partials/Help"

// images
import rightArrowImage from "@/assets/img/storage/icons/right-arrow.svg"
import clearFilterImage from "@/assets/img/icons/clear-filter.svg"

export default function CustomerTypeFilter(props) {
  const [state, setState] = useState({
    loadStatuses: true,
    statuses: [],
  })
  const [anchorEl, setAnchorEl] = useState(null)

  useEffect(() => {
    if (!props.showStatuses) {
      return
    }

    let url = "ordered-parts/statuses?true"

    Object.entries(props.filter).map((filter) => {
      url += "&" + filter[0] + "=" + filter[1]
    })

    Api.get(url).then((res) => {
      setState((prev) => ({
        ...prev,
        statuses: Array.isArray(res.data) ? res.data : [],
        loadStatuses: false,
      }))
    })
  }, [props.filter, props.update, props.showStatuses])

  const handleStatusChange = (id, customerType) => {
    props.handleSearch("customer_type", customerType)

    if (
      props.filter.status_id &&
      props.filter.customer_type === customerType &&
      Number(props.filter.status_id) === id
    ) {
      props.handleSearch("status_id", "")
    } else {
      props.handleSearch("status_id", id)
    }
  }

  function getClientTypeLabel() {
    if (!props.filter.customer_type) {
      return trans("buttons.all")
    }

    if (props.filter.customer_type === "private") {
      return trans("buttons.individual")
    }

    if (props.filter.customer_type === "company") {
      return trans("labels.contractorCompany")
    }
  }

  function getSelectedStatusLabel() {
    const status = state.statuses.find(
      (s) => Number(s.id) === Number(props.filter.status_id)
    )

    if (status) {
      return status.translation ? status.translation.name : status.name
    }

    return ""
  }

  function getSelectedStatusColor() {
    const status = state.statuses.find(
      (s) => Number(s.id) === Number(props.filter.status_id)
    )

    if (status) {
      return status.color
    }

    return ""
  }

  return (
    <>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null)
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        className="customer-type-popover"
      >
        <div
          className="row"
          style={{
            minWidth: "500px",
            maxWidth: "850px",
            padding: "15px",
          }}
        >
          <div className="col">
            <b>{trans("labels.forClientReservation")}</b>
            {state.loadStatuses ? (
              <>
                <Skeleton count={1} height={30} />
                <Skeleton count={1} height={30} />
                <Skeleton count={1} height={30} />
              </>
            ) : (
              <ul>
                {state.statuses.map((s) => (
                  <li
                    key={s.id}
                    onClick={() => handleStatusChange(s.id, "private")}
                  >
                    <Radio
                      checked={
                        props.filter.status_id &&
                        props.filter.customer_type === "private" &&
                        Number(props.filter.status_id) === s.id
                      }
                      size="small"
                      sx={{
                        marginLeft: "-8px",
                      }}
                    />
                    <span
                      style={{
                        backgroundColor: s.color,
                      }}
                      className="color"
                    ></span>
                    {s.translation ? s.translation.name : s.name}{" "}
                    {s.private > 0 ? `(${s.private})` : ""}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="col">
            <b>{trans("labels.contractorCompany")}</b>
            {state.loadStatuses ? (
              <>
                <Skeleton count={1} height={30} />
                <Skeleton count={1} height={30} />
                <Skeleton count={1} height={30} />
              </>
            ) : (
              <ul>
                {state.statuses.map((s) => (
                  <li
                    key={s.id}
                    onClick={() => handleStatusChange(s.id, "company")}
                  >
                    <Radio
                      checked={
                        props.filter.status_id &&
                        props.filter.customer_type === "company" &&
                        Number(props.filter.status_id) === s.id
                      }
                      size="small"
                      sx={{
                        marginLeft: "-8px",
                      }}
                    />
                    <span
                      className="color"
                      style={{
                        backgroundColor: s.color,
                      }}
                    ></span>
                    {s.translation ? s.translation.name : s.name}{" "}
                    {s.company > 0 ? `(${s.company})` : ""}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </Popover>
      <div className="customer-type-filter">
        <label>{trans("labels.forClientReservation")}</label>
        <div className="row">
          <div
            className="fake-input"
            onClick={(e) => {
              setAnchorEl(e.currentTarget)
            }}
          >
            {getSelectedStatusColor() !== "" ? (
              <span
                className="color"
                style={{
                  backgroundColor: getSelectedStatusColor(),
                }}
              ></span>
            ) : (
              <></>
            )}
            {getClientTypeLabel()}
            {props.filter.customer_type !== "" ? (
              <img src={rightArrowImage} alt="arrow" />
            ) : (
              <></>
            )}
            {getSelectedStatusLabel()}
          </div>
          <Button
            onClick={(e) => props.handleFilter(e, "customer_type", "")}
            disabled={props.filter.customer_type === ""}
            className="clear-filter"
          >
            <img src={clearFilterImage} alt="clear" />
          </Button>
        </div>
      </div>
    </>
  )
}
